// Frontend constants matching backend ActionRoles.cs
// This ensures consistency between frontend and backend role mappings

export const ACTION_ROLES = {
  // Project and Report Delete Actions
  DELETE_PROJECT: ['System Admin'],
  DELETE_CA_REPORT: ['System Admin', 'Inspector'],
  DELETE_CC_REPORT: ['System Admin', 'Inspector'],
  DELETE_QCC_REPORT: ['System Admin', 'Inspector'],

  // Line item actions
  ADD_LINE_ITEM: ['System Admin', 'Inspector'],
  EDIT_LINE_ITEM_DIVISIONS: ['System Admin', 'Inspector'],
  DELETE_LINE_ITEM: ['System Admin', 'Inspector'],

  // User management
  MANAGE_USERS: ['System Admin'],

  // Data export
  EXPORT_PROJECTS_CSV: ['System Admin'],
};
